import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const PrivateRoute = () => {
  const { user, isLoading } = useAuth();

  if (isLoading) return <div>Loading...</div>;
  // Non connecte sur une route protegee -> page "Connexion requise" (401) plutot que /login direct.
  if (!user) return <Navigate to="/session-expiree" replace />;

  return <Outlet />; // <-- rendra les routes enfants
};

export default PrivateRoute;